import DirectusCombobox from "../combobox";
import FilterWrapper from "components/filter/wrapper";
import React from "react";
import client from "directus/src/client";

export default function SubIndustryCombobox({
  filter,
  hideLabel,
  className = "w-full max-w-[280px]",
  ...props
}) {
  if (hideLabel) {
    return (
      <div className={className}>
        <DirectusCombobox
          client={client}
          limit={-1}
          collection="industries"
          fields={["id", "name"]}
          searchKeys={["name"]}
          filter={filter}
          placeholder="Search & Select"
          {...props}
        />
      </div>
    );
  }

  return (
    <FilterWrapper label="Sub Industry" className={className}>
      <DirectusCombobox
        client={client}
        limit={-1}
        collection="industries"
        fields={["id", "name"]}
        searchKeys={["name"]}
        filter={filter}
        {...props}
      />
    </FilterWrapper>
  );
}
